/* =====================================================================
   dtc-landing.js — sem jQuery e sem Slick.
   O jQuery v3.4.1 (87 KiB) e o Slick (42 KiB) sairam daqui: existiam
   apenas para o sliders.js, que eram 5 KiB de configuracao. Os outros
   tres blocos (config, menu-drawer, app) ja eram JavaScript puro --
   o app.js define os proprios $ e $$ sobre querySelector.
   ===================================================================== */

/* assets/js/config.js */
/* =====================================================================
   CONFIG.JS — links do rodape.

   Os links de checkout e os pacotes com preco escrito na mao sairam daqui:
   quem vende agora e o bloco do Kaching, que usa o carrinho e o checkout
   da propria Shopify. Preco, moeda e frete vem da loja, nao deste arquivo.
   ===================================================================== */
(function () {
  'use strict';

  /* ---- LINKS DO RODAPE (menu e politicas) --------------------------- */
  /* Trocar '#product-packs' pela URL real de cada pagina quando existirem. */
  var FOOTER = {
    shopNow:        '#product-packs',
    trackOrder:     '/pages/track-order',
    contact:        '/pages/contact',
    refundPolicy:   '/policies/refund-policy',
    shippingPolicy: '/policies/shipping-policy',
    privacyPolicy:  '/policies/privacy-policy',
    termsOfService: '#product-packs'
  };

  /* =====================================================================
     Daqui pra baixo NAO precisa mexer.
     ===================================================================== */

  window.LZ = { footer: FOOTER };

  /* Cada link do rodape e identificado pelo data-lf-link, nao pelo texto,
     pra nao quebrar quando o idioma ou a copy mudar. */
  function applyFooterLinks() {
    var map = {
      'shop-now':         FOOTER.shopNow,
      'track-order':      FOOTER.trackOrder,
      'contact':          FOOTER.contact,
      'refund-policy':    FOOTER.refundPolicy,
      'shipping-policy':  FOOTER.shippingPolicy,
      'privacy-policy':   FOOTER.privacyPolicy,
      'terms-of-service': FOOTER.termsOfService
    };
    document.querySelectorAll('.lf-footer__link').forEach(function (a) {
      var key = a.getAttribute('data-lf-link');
      if (map[key]) a.setAttribute('href', map[key]);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFooterLinks);
  } else {
    applyFooterLinks();
  }
})();
/* ---- bloco ---- */

/* assets/js/sliders.js */
/* =====================================================================
   SLIDERS.JS — versao nativa: sem jQuery, sem Slick.
   Usa scroll-snap do CSS para o arrasto (o navegador faz sozinho) e um
   pouco de JS so para setas, bolinhas e a sincronia galeria<->miniaturas.
   ===================================================================== */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  var SECTION  = 'sections--20177149886603__';
  var TEMPLATE = 'template--20177150607499__';

  /* ---- utilitarios de faixa ---------------------------------------- */
  /* O CSS do tema tem varias regras presas a :not(.slick-initialized) --
     elas descrevem o estado ANTES do carrossel montar (esconder slides,
     reservar espaco). Sem o Slick essa classe nunca apareceria e aquelas
     regras passariam a valer para sempre, escondendo fotos. Marcamos a
     faixa do mesmo jeito que o Slick marcava. */
  function marcarPronto(el) {
    el.classList.add('slick-initialized', 'slick-slider');
  }

  function slides(track) { return Array.prototype.slice.call(track.children); }

  function indiceAtual(track) {
    var kids = slides(track);
    if (!kids.length) return 0;
    var centro = track.scrollLeft + track.clientWidth / 2;
    var melhor = 0, dist = Infinity;
    kids.forEach(function (k, i) {
      var c = k.offsetLeft - track.offsetLeft + k.offsetWidth / 2;
      var d = Math.abs(c - centro);
      if (d < dist) { dist = d; melhor = i; }
    });
    return melhor;
  }

  function irPara(track, i) {
    var kids = slides(track);
    if (!kids.length) return;
    i = Math.max(0, Math.min(i, kids.length - 1));
    track.scrollTo({ left: kids[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
  }

  function aoParar(track, cb) {
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(cb, 90);
    }, { passive: true });
  }

  /* ---- marquee: faixa que corre sozinha, feita em CSS --------------- */
  function marquee(sel) {
    var el = $(sel);
    if (!el || el.dataset.lzMq) return;
    el.dataset.lzMq = '1';
    var wrap = document.createElement('div');
    wrap.className = 'lz-mq';
    el.parentNode.insertBefore(wrap, el);
    wrap.appendChild(el);
    el.classList.add('lz-mq__run');
    marcarPronto(el);
    /* duplica os itens para o loop nao ter emenda visivel */
    el.insertAdjacentHTML('beforeend', el.innerHTML);
  }

  /* ---- carrossel comum: setas + bolinhas --------------------------- */
  function carousel(id) {
    var track = $('.slider_' + id);
    if (!track) return;
    track.classList.add('lz-track', 'lz-track--carousel');
    marcarPronto(track);

    var prev = $('.prev_' + id), next = $('.next_' + id), dots = $('.dots_' + id);

    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); irPara(track, indiceAtual(track) - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); irPara(track, indiceAtual(track) + 1); });

    if (dots) {
      dots.innerHTML = '';
      var ul = document.createElement('ul');
      /* o tema estiliza .slick-dots li/button; sem essa classe as bolinhas
         viram lista com marcador e a secao cresce */
      ul.className = 'slick-dots';
      slides(track).forEach(function (_, i) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button'; b.textContent = String(i + 1);
        b.addEventListener('click', function () { irPara(track, i); });
        li.appendChild(b); ul.appendChild(li);
      });
      dots.appendChild(ul);
      var marcar = function () {
        var a = indiceAtual(track);
        $$('li', ul).forEach(function (li, i) { li.classList.toggle('slick-active', i === a); });
      };
      aoParar(track, marcar); marcar();
    }
  }

  /* ---- galeria: imagem grande + miniaturas sincronizadas ----------- */
  function gallery(id) {
    var main   = $('.slider_' + id);
    var thumbs = $('.slider_thumb_' + id);
    if (!main) return;
    main.classList.add('lz-track', 'lz-track--main');
    marcarPronto(main);
    if (thumbs) { thumbs.classList.add('lz-track', 'lz-track--thumbs'); marcarPronto(thumbs); }

    var prev = $('.prev_' + id + '_main_slider'), next = $('.next_' + id + '_main_slider');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); irPara(main, indiceAtual(main) - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); irPara(main, indiceAtual(main) + 1); });

    if (thumbs) {
      slides(thumbs).forEach(function (t, i) {
        t.addEventListener('click', function () { irPara(main, i); });
      });
      var sincronizar = function () {
        var a = indiceAtual(main);
        slides(thumbs).forEach(function (t, i) { t.classList.toggle('is-active', i === a); });
        var alvo = slides(thumbs)[a];
        if (alvo) {
          var fora = alvo.offsetLeft - thumbs.offsetLeft;
          if (fora < thumbs.scrollLeft || fora + alvo.offsetWidth > thumbs.scrollLeft + thumbs.clientWidth) {
            thumbs.scrollTo({ left: fora, behavior: 'smooth' });
          }
        }
      };
      aoParar(main, sincronizar); sincronizar();
    }
  }

  function iniciar() {
    marquee('.slider_' + SECTION  + 'icon_with_text_lp_GAGVFP');
    marquee('.slider_' + TEMPLATE + 'icon_with_text_lp_GAGVFP');
    carousel('videos_fmwFBm');
    carousel(TEMPLATE + 'review_slider_lp_mDXM7m');
    carousel(TEMPLATE + 'column_slider_lp_Ajmc3h');
    gallery(TEMPLATE + 'product_lp_czeKee');
    gallery(TEMPLATE + 'product_lp_czeKee_1');
    gallery(TEMPLATE + 'product_lp_czeKee_2');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();

/* ---- bloco ---- */

/* assets/js/menu-drawer.js */
/* =====================================================================
   Menu lateral do cabecalho.

   Este arquivo era o cart.js: montava uma gaveta de carrinho a partir de
   precos escritos no proprio JS e mandava o cliente pro checkout externo
   de outra loja. Tudo isso saiu. O carrinho e o checkout agora sao os da
   Shopify — o icone do cabecalho leva pro /cart e quem enche o carrinho
   e o bloco do Kaching.
   ===================================================================== */
(function () {
  'use strict';

  function toggleDrawer(open) {
    var drawer = document.getElementById('menu-drawer');
    var overlay = document.querySelector('.custom_overlay');
    if (drawer) drawer.classList.toggle('open', open);
    if (overlay) overlay.classList.toggle('active', open);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (e) {
      var t = e.target;

      if (t.closest('#drawer-toggle')) {
        toggleDrawer(true);
        return;
      }
      if (t.closest('#drawer-close')) {
        toggleDrawer(false);
        return;
      }
      if (!t.closest('#menu-drawer, #drawer-toggle')) {
        toggleDrawer(false);
      }
    }, true);
  });
})();
/* ---- bloco ---- */

/* assets/js/app.js */
/* =====================================================================
   APP.JS — comportamento geral da pagina.

   Reune o que antes estava espalhado em: 01, 02, 03, 06, 07, 08, 11,
   14, 15, 17, 18, 20, 21, 22, 27 (.js) mais o script inline do rodape.

   Secoes:
     1. Utilitarios
     2. Altura real da viewport
     3. Datas dinamicas
     4. Contadores regressivos (banner + entrega)
     5. Acordeoes, abas e videos
     6. Contadores animados e timeline
     7. Reviews (ver mais / ver menos)
     8. Assinatura e precos
     9. Explorador de ingredientes
    10. Popup nutricional
    11. Barras fixas (sticky CTA)
    12. Imagens dos carrosseis
   ===================================================================== */
(function () {
  'use strict';

  /* ==================================================================
     1. Utilitarios
     ================================================================== */

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function pad(value) {
    return String(Math.max(0, Math.floor(value))).padStart(2, '0');
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  /* ==================================================================
     2. Altura real da viewport
     A gaveta do carrinho e o modal usam --real-vh. Sem isso ficam com
     altura errada em qualquer tela que nao tenha 880px.
     ================================================================== */

  function syncViewportHeight() {
    document.documentElement.style.setProperty('--real-vh', window.innerHeight + 'px');
  }

  syncViewportHeight();
  window.addEventListener('resize', debounce(syncViewportHeight, 150), { passive: true });
  window.addEventListener('orientationchange', syncViewportHeight, { passive: true });

  /* ==================================================================
     3. Datas dinamicas
     Elementos com data-lz-date recebem a data formatada.
     O HTML ja traz um texto de fallback caso o JS falhe.
     ================================================================== */

  var DATE_FORMATS = {
    'month-day': { month: 'long', day: 'numeric' },
    'weekday-month-day': { weekday: 'short', month: 'long', day: 'numeric' }
  };

  function initDates() {
    $$('[data-lz-date]').forEach(function (el) {
      var spec = el.getAttribute('data-lz-date');
      var format = DATE_FORMATS[el.getAttribute('data-lz-date-format')] || DATE_FORMATS['month-day'];
      var date = new Date();
      var offset = /^\+(\d+)$/.exec(spec);
      if (offset) date.setDate(date.getDate() + parseInt(offset[1], 10));

      try {
        el.textContent = date.toLocaleDateString('fr-FR', format);
        el.setAttribute('datetime', date.toISOString().slice(0, 10));
      } catch (e) {
        /* mantem o texto estatico do HTML */
      }
    });
  }

  /* ==================================================================
     4. Contadores regressivos

     Antes eram 4 arquivos quase identicos (03, 06, 07, 08). Agora ha
     uma funcao por tipo de timer e uma lista de configuracao no final.
     ================================================================== */

  function to24Hour(hour12, period) {
    hour12 = parseInt(hour12, 10);
    if (String(period).toLowerCase() === 'am') return hour12 === 12 ? 0 : hour12;
    return hour12 === 12 ? 12 : hour12 + 12;
  }

  /* Proxima ocorrencia de um horario fixo do dia (ex.: todo dia as 18h). */
  function nextDailyReset(hour12, minute, period) {
    var now = new Date();
    var next = new Date(now);
    next.setHours(to24Hour(hour12, period), minute, 0, 0);
    if (next.getTime() <= now.getTime()) next.setDate(next.getDate() + 1);
    return next.getTime();
  }

  /* Data de entrega: hoje + N dias, pulando domingo.
     N = 10 para bater com o prazo anunciado no FAQ (5 a 10 dias uteis):
     a data mostrada e o LIMITE, nao a media. Compra dia 1 -> ate dia 11. */
  function deliveryDate(daysToAdd) {
    var date = new Date();
    date.setDate(date.getDate() + daysToAdd);
    while (date.getDay() === 0) date.setDate(date.getDate() + 1);
    return date;
  }

  function formatDeliveryDate(date) {
    /* frances poe o dia antes do mes: "dimanche 23 aout".
       O 'en-US' cravado aqui era heranca do site clonado. */
    return date.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
  }

  /* --- 4a. Timer do banner do topo (hh/mm/ss em elementos separados) -- */

  function initBannerTimer(sectionId) {
    var timer = document.getElementById('countdown-' + sectionId);
    if (!timer) return;

    var hoursEl = document.getElementById('hh-' + sectionId);
    var minutesEl = document.getElementById('mm-' + sectionId);
    var secondsEl = document.getElementById('ss-' + sectionId);
    if (!hoursEl || !minutesEl || !secondsEl) return;

    function toInt(attr, fallback) {
      var parsed = parseInt(timer.getAttribute(attr), 10);
      return isNaN(parsed) ? fallback : parsed;
    }

    var isDaily = (timer.getAttribute('data-reset-mode') || 'refresh_reset') === 'daily_reset_time';

    function endTime() {
      if (isDaily) {
        return nextDailyReset(
          toInt('data-daily-hour', 9),
          toInt('data-daily-minute', 0),
          timer.getAttribute('data-daily-period') || 'pm'
        );
      }
      var ms = (toInt('data-duration-hours', 2) * 3600 +
                toInt('data-duration-minutes', 0) * 60 +
                toInt('data-duration-seconds', 0)) * 1000;
      return Date.now() + ms;
    }

    var target = endTime();

    function tick() {
      /* No modo diario o alvo e sempre recalculado; no modo duracao, fixo. */
      var diff = (isDaily ? nextDailyReset(
        toInt('data-daily-hour', 9),
        toInt('data-daily-minute', 0),
        timer.getAttribute('data-daily-period') || 'pm'
      ) : target) - Date.now();

      if (diff < 0) diff = 0;

      var total = Math.floor(diff / 1000);
      hoursEl.textContent = pad(total / 3600);
      minutesEl.textContent = pad((total % 3600) / 60);
      secondsEl.textContent = pad(total % 60);
    }

    tick();
    setInterval(tick, 1000);
  }

  /* --- 4b. Timer de entrega ----------------------------------------- */

  /* mode 'duration': conta N horas a partir da primeira visita (localStorage).
     mode 'daily':    conta ate um horario fixo do dia. */
  function initDeliveryTimer(config) {
    var root = document.getElementById('delivery-timer-' + config.id);
    if (!root) return;

    var dateEl = $('[data-delivery-date]', root);
    var countdownEl = $('[data-countdown]', root);

    if (dateEl) dateEl.textContent = formatDeliveryDate(deliveryDate(config.daysToAdd || 1));
    if (!countdownEl) return;

    var storageKey = 'delivery-timer-start-' + config.id;
    var durationMs = (config.hours || 0) * 3600 * 1000;

    function durationEnd() {
      var now = Date.now();
      var saved = parseInt(localStorage.getItem(storageKey), 10);
      if (!saved || isNaN(saved) || now - saved >= durationMs) {
        try { localStorage.setItem(storageKey, String(now)); } catch (e) {}
        saved = now;
      }
      return saved + durationMs;
    }

    function tick() {
      var diff = (config.mode === 'daily'
        ? nextDailyReset(config.resetHour, config.resetMinute || 0, config.resetPeriod)
        : durationEnd()) - Date.now();

      if (diff < 0) diff = 0;

      var total = Math.floor(diff / 1000);
      var hours = Math.floor(total / 3600);
      var minutes = Math.floor((total % 3600) / 60);

      countdownEl.textContent = config.mode === 'daily'
        ? hours + ' h ' + minutes + ' min'
        : hours + ' h ' + pad(minutes) + ' min ' + pad(total % 60) + ' s';
    }

    tick();
    setInterval(tick, 1000);
  }

  /* --- 4c. Lista de timers da pagina -------------------------------- */

  function initTimers() {
    initBannerTimer('sections--20177149886603__anouncment_timer_AXPiaM');

    [
      { id: 'delivery_timer_new_4aUYU8', mode: 'duration', hours: 2.5, daysToAdd: 10 },
      { id: 'delivery_timer_new_6DB3Yx', mode: 'duration', hours: 1.5, daysToAdd: 10 },
      { id: 'delivery_timer_cdizWF', mode: 'daily', resetHour: 6, resetMinute: 0, resetPeriod: 'PM', daysToAdd: 10 }
    ].forEach(initDeliveryTimer);
  }

  /* ==================================================================
     5. Acordeoes, abas e videos
     ================================================================== */

  var ACCORDION_SELECTOR = '.question_product, .faq_question, .section3_icons_lp .icons_with_text_item_flex';

  function slideToggle(el, open) {
    if (!el) return;
    if (open) {
      el.style.display = 'block';
      el.style.maxHeight = el.scrollHeight + 'px';
    } else {
      el.style.maxHeight = '0px';
      el.style.display = 'none';
    }
  }

  function initInteractions() {
    document.addEventListener('click', function (e) {
      var t = e.target;

      /* --- Acordeao: abre um, fecha os outros --- */
      var header = t.closest(ACCORDION_SELECTOR);
      if (header) {
        var wasActive = header.classList.contains('active');
        $$(ACCORDION_SELECTOR).forEach(function (other) {
          other.classList.remove('active');
          slideToggle(other.nextElementSibling, false);
        });
        if (!wasActive) {
          header.classList.add('active');
          slideToggle(header.nextElementSibling, true);
        }
        return;
      }

      /* --- Play/pause dos videos --- */
      var videoBtn = t.closest('.custom_button');
      if (videoBtn) {
        var wrapper = videoBtn.closest('.video_wrapper_custom');
        var video = wrapper ? $('video', wrapper) : null;
        if (video) {
          if (videoBtn.classList.contains('active')) {
            video.pause();
            videoBtn.classList.remove('active');
            if (wrapper) wrapper.classList.remove('video-active');
          } else {
            video.play();
            videoBtn.classList.add('active');
            if (wrapper) wrapper.classList.add('video-active');
          }
        }
        return;
      }

      /* --- Abas --- */
      var tab = t.closest('.tab_item_pdp');
      if (tab) {
        var tabId = tab.getAttribute('data_tab');
        $$('.tab_item_pdp').forEach(function (el) { el.classList.remove('active'); });
        tab.classList.add('active');
        $$('.tab_content_pdp').forEach(function (panel) {
          panel.style.display = panel.getAttribute('data_tab') === tabId ? 'block' : 'none';
        });
        return;
      }

      /* --- Ancoras com rolagem suave --- */
      var anchor = t.closest('a[href^="#"]');
      if (anchor) {
        var href = anchor.getAttribute('href');
        var target = href === '#' ? $('.landing_page_product') : $(href);
        if (target) {
          /* [ATLAS 30/08] Quem rola e snippets/lz-rolagem.liquid, que controla
             a duracao e desconta a barra fixa. Ele intercepta em fase de
             CAPTURA com stopPropagation, entao normalmente este trecho nem
             roda. Se rodar (snippet ausente), so cancela o pulo do hash e
             deixa o navegador levar — NAO rolar aqui tambem, senao sao duas
             rolagens somadas e o movimento sai arrastado (medido: 2.433ms
             para 1.500 pedidos). */
          if (!window.lzRolarAte) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }
    });

    /* Cabecalho perde a transparencia ao rolar. */
    window.addEventListener('scroll', function () {
      document.body.classList.toggle('remove_transparent', window.scrollY > 30);
    }, { passive: true });

    /* Classe de sistema operacional (usada por alguns ajustes de CSS). */
    document.body.classList.add(
      navigator.userAgent.indexOf('Mac') > -1 ? 'mac-os' : 'window-os'
    );
  }

  /* ==================================================================
     6. Contadores animados e timeline
     ================================================================== */

  function animateCounter(el) {
    var target = Number(el.getAttribute('data-value') || el.dataset.value || 0);
    var duration = 2000;
    var start = null;

    function step(timestamp) {
      if (start === null) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      /* easing "swing", igual ao padrao do jQuery */
      var eased = 0.5 - Math.cos(progress * Math.PI) / 2;
      el.textContent = Math.ceil(eased * target);
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function initScrollEffects() {
    var counterBlocks = $$('.custom_counter .icons_with_text_flex');
    var timelineItems = $$('.timeline_icons .icons_with_text_item');

    if (!counterBlocks.length && !timelineItems.length) return;

    if ('IntersectionObserver' in window) {
      if (counterBlocks.length) {
        var counterObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            counterObserver.unobserve(entry.target);
            entry.target.classList.add('start_count');
            $$('.count_js', entry.target).forEach(animateCounter);
          });
        }, { threshold: 0.4 });
        counterBlocks.forEach(function (block) { counterObserver.observe(block); });
      }

      if (timelineItems.length) {
        var timelineObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            entry.target.classList.toggle('active', entry.isIntersecting);
          });
        }, { rootMargin: '0px 0px -30% 0px' });
        timelineItems.forEach(function (item) { timelineObserver.observe(item); });
      }
      return;
    }

    /* Fallback para navegadores muito antigos: mostra tudo. */
    counterBlocks.forEach(function (block) {
      block.classList.add('start_count');
      $$('.count_js', block).forEach(animateCounter);
    });
    timelineItems.forEach(function (item) { item.classList.add('active'); });
  }

  /* ==================================================================
     7. Reviews — botoes "ver mais" / "ver menos"
     ================================================================== */

  var REVIEWS_VISIBLE = 3;
  var REVIEWS_STEP = 3;

  function initReviews() {
    var items = $$('.review_with_text_landing_page_item');
    if (!items.length) return;

    var shown = REVIEWS_VISIBLE;

    function render() {
      items.forEach(function (item, index) {
        var visible = index < shown;
        item.style.display = visible ? '' : 'none';
        item.classList.toggle('active', visible);
      });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('.trigger_reviews_js_show')) {
        shown = Math.min(shown + REVIEWS_STEP, items.length);
        render();
      } else if (e.target.closest('.trigger_reviews_js_hide')) {
        shown = REVIEWS_VISIBLE;
        render();
      }
    });

    render();
  }

  /* ==================================================================
     8. Assinatura e precos
     ================================================================== */

  function initSubscription() {
    document.addEventListener('click', function (e) {
      var t = e.target;

      /* Selecao de pacote (1 / 2 / 3 frascos). */
      var qtyItem = t.closest('.quantity_item');
      if (qtyItem) {
        $$('.quantity_item').forEach(function (el) { el.classList.remove('active'); });
        qtyItem.classList.add('active');

        var dataTab = qtyItem.getAttribute('data_tab');
        $$('.price_trigger').forEach(function (el) {
          var match = el.getAttribute('data_tab') === dataTab;
          el.style.display = match ? '' : 'none';
          el.classList.toggle('active', match);
        });

        var label = qtyItem.getAttribute('label');
        var labelEl = $('.product_text_3 strong');
        if (labelEl && label) labelEl.textContent = label;
        return;
      }

      /* Alternar entre compra unica e assinatura. */
      var subItem = t.closest('.subscription_item');
      if (subItem) {
        $$('.subscription_item').forEach(function (el) { el.classList.remove('active'); });
        subItem.classList.add('active');

        var tab = subItem.getAttribute('data_tab');
        $$('.subscription_trigger').forEach(function (el) {
          el.style.display = el.getAttribute('data_tab') === tab ? '' : 'none';
        });
        return;
      }

      /* Caixa de assinatura (liga/desliga). */
      var subBox = t.closest('.subscription_new_box');
      if (subBox) {
        var turningOn = !subBox.classList.contains('active');
        $$('.subscription_new_box').forEach(function (el) {
          el.classList.toggle('active', turningOn);
        });
        var targetTab = turningOn ? '2' : '1';
        var target = $('.subscription_item[data_tab="' + targetTab + '"]');
        if (target) target.click();
        return;
      }

      /* Frequencia de entrega. */
      var freq = t.closest('.sub_flex_bottom_delivery_item');
      if (freq) {
        $$('.sub_flex_bottom_delivery_item').forEach(function (el) { el.classList.remove('active'); });
        freq.classList.add('active');
        var labelSpan = $('.landing_page_product .sub_flex_bottom_delivery_label span');
        if (labelSpan) labelSpan.textContent = freq.textContent;
      }
    });
  }

  /* Copia os precos calculados do data-attribute para o texto visivel. */
  function initLandingPrices() {
    $$('.landing_product_flex').forEach(function (wrap) {
      var host = $('.quantity_landing_page', wrap);
      if (!host) return;

      var pairs = [
        ['.quantity_price.price-second', 'span.second-price', host.getAttribute('data-sub-total-3-money')],
        ['.quantity_price.price-third', 'span.third-price', host.getAttribute('data-sub-total-5-money')]
      ];

      pairs.forEach(function (pair) {
        var priceEl = $(pair[0], wrap);
        var spanEl = $(pair[1], wrap);
        var money = pair[2];
        if (!money) return;

        if (priceEl) {
          /* Preserva o <s> do preco riscado. */
          var strike = priceEl.querySelector('s');
          priceEl.textContent = money;
          if (strike) priceEl.appendChild(strike);
        }
        if (spanEl) spanEl.textContent = money;
      });
    });
  }

  /* ==================================================================
     9. Explorador de ingredientes

     Abas de produto -> lista de ingredientes -> cartao de detalhe.
     No mobile os cartoes viram um carrossel horizontal com bolinhas.
     ================================================================== */

  var INGREDIENTS_ID = 'ingredients-explorer-template--20177150607499__ingredient_section_tQfrHU';

  function initIngredients() {
    var root = document.getElementById(INGREDIENTS_ID);
    if (!root) return;

    var tabs = $('[data-product-tabs]', root);
    var productPanels = $('[data-product-panels]', root);
    var lists = $('[data-ingredient-lists]', root);
    var details = $('[data-detail-panels]', root);
    var dots = $('[data-dots-panels]', root);
    var prevBtn = $('[data-prev-btn]', root);
    var nextBtn = $('[data-next-btn]', root);

    if (!productPanels || !lists || !details || !dots || !prevBtn || !nextBtn) return;

    var mobile = window.matchMedia('(max-width: 759px)');
    var state = { product: 0, ingredient: 0 };

    function cards(product) {
      var panel = details.querySelector('[data-detail-panel="' + product + '"]');
      var track = panel ? $('[data-detail-track]', panel) : null;
      return track ? $$('[data-card-panel]', track) : [];
    }

    function track(product) {
      var panel = details.querySelector('[data-detail-panel="' + product + '"]');
      return panel ? $('[data-detail-track]', panel) : null;
    }

    /* Mostra apenas o painel cujo atributo bate com o indice ativo. */
    function showPanel(container, attr, activeIndex) {
      $$('[' + attr + ']', container).forEach(function (panel) {
        var isActive = Number(panel.getAttribute(attr)) === activeIndex;
        panel.classList.toggle('is-active', isActive);
        if (isActive) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
    }

    function markActive(elements, attr, activeIndex) {
      elements.forEach(function (el) {
        el.classList.toggle('is-active', Number(el.getAttribute(attr)) === activeIndex);
      });
    }

    function renderIngredient(skipScroll) {
      var listPanel = lists.querySelector('[data-ingredient-list-panel="' + state.product + '"]');
      markActive(listPanel ? $$('[data-ingredient-index]', listPanel) : [],
                 'data-ingredient-index', state.ingredient);

      var dotsPanel = dots.querySelector('[data-dots-panel="' + state.product + '"]');
      markActive(dotsPanel ? $$('[data-dot-index]', dotsPanel) : [],
                 'data-dot-index', state.ingredient);

      /* No desktop so o cartao ativo aparece; no mobile todos ficam no track. */
      cards(state.product).forEach(function (card) {
        var isActive = Number(card.getAttribute('data-card-panel')) === state.ingredient;
        card.classList.toggle('is-active', isActive);
        if (mobile.matches || isActive) card.removeAttribute('hidden');
        else card.setAttribute('hidden', '');
      });

      if (mobile.matches && !skipScroll) {
        var currentTrack = track(state.product);
        var card = cards(state.product)[state.ingredient];
        if (currentTrack && card) {
          currentTrack.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
        }
      }

      var total = cards(state.product).length || 1;
      prevBtn.disabled = state.ingredient <= 0;
      nextBtn.disabled = state.ingredient >= total - 1;
    }

    function switchProduct(index) {
      state.product = index;
      state.ingredient = 0;

      if (tabs) markActive($$('[data-product-index]', tabs), 'data-product-index', index);
      showPanel(productPanels, 'data-product-panel', index);
      showPanel(lists, 'data-ingredient-list-panel', index);
      showPanel(details, 'data-detail-panel', index);
      showPanel(dots, 'data-dots-panel', index);

      renderIngredient(true);

      var currentTrack = track(index);
      if (mobile.matches && currentTrack) currentTrack.scrollLeft = 0;
    }

    function switchIngredient(index, skipScroll) {
      state.ingredient = index;
      renderIngredient(skipScroll);
    }

    if (tabs) {
      tabs.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-product-index]');
        if (!btn) return;
        var index = Number(btn.getAttribute('data-product-index'));
        if (!isNaN(index)) switchProduct(index);
      });
    }

    /* Lista de ingredientes e bolinhas usam a mesma logica. */
    [[lists, 'data-ingredient-index'], [dots, 'data-dot-index']].forEach(function (pair) {
      pair[0].addEventListener('click', function (e) {
        var btn = e.target.closest('[' + pair[1] + ']');
        if (!btn) return;
        var product = Number(btn.getAttribute('data-product-index'));
        var index = Number(btn.getAttribute(pair[1]));
        if (isNaN(index) || product !== state.product) return;
        switchIngredient(index, false);
      });
    });

    prevBtn.addEventListener('click', function () {
      if (state.ingredient > 0) switchIngredient(state.ingredient - 1, false);
    });

    nextBtn.addEventListener('click', function () {
      if (state.ingredient < cards(state.product).length - 1) {
        switchIngredient(state.ingredient + 1, false);
      }
    });

    /* Arrastar o carrossel no mobile atualiza a bolinha ativa. */
    $$('[data-detail-track]', details).forEach(function (el) {
      var ticking = false;
      el.addEventListener('scroll', function () {
        if (!mobile.matches || ticking || el.closest('[hidden]')) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var list = cards(state.product);
          var closest = 0;
          var shortest = Infinity;
          list.forEach(function (card, index) {
            var distance = Math.abs(card.offsetLeft - el.scrollLeft);
            if (distance < shortest) { shortest = distance; closest = index; }
          });
          if (closest !== state.ingredient) switchIngredient(closest, true);
        });
      }, { passive: true });
    });

    /* --- Reordenacao do layout no mobile --- */
    var productWrap = $('.ve-ingredients__product-wrap', root);
    var detailPanels = $('.ve-ingredients__detail-panels', root);
    var controls = $('.ve-ingredients__controls', root);

    if (productWrap && detailPanels && controls) {
      var detailHome = { parent: detailPanels.parentNode, next: detailPanels.nextSibling };
      var controlsHome = { parent: controls.parentNode, next: controls.nextSibling };

      function restore(el, home) {
        if (home.next) home.parent.insertBefore(el, home.next);
        else home.parent.appendChild(el);
      }

      function updateLayout() {
        if (mobile.matches) {
          if (productWrap.nextElementSibling !== detailPanels) productWrap.after(detailPanels);
          if (detailPanels.nextElementSibling !== controls) detailPanels.after(controls);
        } else {
          restore(detailPanels, detailHome);
          restore(controls, controlsHome);
        }
        renderIngredient(true);
      }

      updateLayout();
      mobile.addEventListener('change', updateLayout);
    }

    switchProduct(0);
  }

  /* ==================================================================
     10. Popup nutricional
     ================================================================== */

  function initPopup() {
    var activeModal = null;
    var activeTrigger = null;

    function close(nextHref) {
      if (!activeModal) return;

      var modal = activeModal;
      var trigger = activeTrigger;
      activeModal = null;
      activeTrigger = null;

      modal.classList.remove('is-active');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');

      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';

      /* Espera a animacao de saida terminar antes de esconder de vez. */
      setTimeout(function () {
        modal.hidden = true;

        if (nextHref) {
          if (nextHref.charAt(0) === '#') {
            var target = $(nextHref);
            if (target) {
              var top = window.pageYOffset + target.getBoundingClientRect().top -
                        (window.innerHeight / 2 - target.offsetHeight / 2);
              window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
              history.replaceState(null, '', nextHref);
              return;
            }
          }
          window.location.href = nextHref;
          return;
        }

        if (trigger && typeof trigger.focus === 'function') trigger.focus();
      }, 350);
    }

    document.addEventListener('click', function (e) {
      /* Abrir */
      var openBtn = e.target.closest('[data-popup-open]');
      if (openBtn) {
        var targetId = openBtn.getAttribute('data-popup-target') ||
                       openBtn.getAttribute('aria-controls');
        var modal = targetId ? document.getElementById(targetId) : null;
        var dialog = modal ? $('.nutrition-popup__dialog', modal) : null;
        if (!modal || !dialog) return;

        activeModal = modal;
        activeTrigger = openBtn;

        modal.hidden = false;
        openBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';

        requestAnimationFrame(function () {
          modal.classList.add('is-active');
          dialog.focus();
        });
        return;
      }

      if (!activeModal) return;

      /* Fechar */
      var closeBtn = e.target.closest('[data-popup-close]');
      if (closeBtn && activeModal.contains(closeBtn)) {
        close();
        return;
      }

      /* Link dentro do popup: fecha e depois navega. */
      var link = e.target.closest('.nutrition-popup__cta');
      if (link && activeModal.contains(link)) {
        var href = link.getAttribute('href');
        if (href && href !== '#') {
          e.preventDefault();
          close(href);
        } else {
          close();
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && activeModal) close();
    });
  }

  /* ==================================================================
     11. Barras fixas (sticky CTA)
     ================================================================== */

  /* Barra que aparece quando nenhum dos botoes de compra esta na tela. */
  function initStickyBar(sectionId, barSelector, watchedSelectors) {
    var root = document.getElementById(sectionId);
    if (!root) return;

    var bar = $(barSelector, root);
    if (!bar) return;

    function anyVisible() {
      return watchedSelectors.some(function (selector) {
        var el = $(selector);
        if (!el) return false;
        var style = window.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden') return false;
        var rect = el.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < window.innerHeight;
      });
    }

    function update() {
      bar.classList.toggle('active', !anyVisible());
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* Barra que aparece depois de rolar, exceto sobre a secao de compra. */
  function initScrollCta(barId, sectionId, showAfter) {
    var bar = document.getElementById(barId);
    var section = document.getElementById(sectionId);
    if (!bar || !section) return;

    var ticking = false;

    function update() {
      var rect = section.getBoundingClientRect();
      var viewport = window.innerHeight || document.documentElement.clientHeight;
      var sectionInView = rect.top < viewport * 0.6 && rect.bottom > 0;
      bar.classList.toggle('is-visible', window.scrollY > showAfter && !sectionInView);
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    window.addEventListener('resize', update);
    update();
  }

  /* Barra de compra da PDP.

     Antes usava initStickyBar, que esconde a barra sempre que qualquer
     elemento de uma lista esta visivel. Na PDP essa lista inclui
     .product_images e .question_product, que aparecem em quase toda a
     pagina — na pratica a barra nunca aparecia.

     Regra nova: aparece quando o botao de compra sai por cima da tela e
     nao some mais. O clique nao compra: os links dela apontam para
     #product-packs, ou seja, levam a pessoa de volta PARA CIMA, ao bloco
     de compra, onde ela escolhe o kit e usa o botao de verdade. */
  function initStickyAposCompra(sectionId, barSelector) {
    var root = document.getElementById(sectionId);
    if (!root) return;
    var bar = $(barSelector, root);
    if (!bar) return;

    function referencia() {
      return $('.lz-atc__button') || document.getElementById('product-packs');
    }

    var mostrada = false;
    function update() {
      if (mostrada) return;
      var ref = referencia();
      if (!ref) return;
      /* passou por cima da tela = a pessoa rolou para baixo do botao */
      if (ref.getBoundingClientRect().bottom < 0) {
        mostrada = true;
        bar.classList.add('active');
        window.removeEventListener('scroll', update);
        window.removeEventListener('resize', update);
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initStickyBars() {
    initStickyAposCompra(
      'StickyBottomBar-template--20177150607499__sticky_form_DVmBHG',
      '.custom_sticky_bottom-shopi'
    );

    initScrollCta('sticky-cta', 'product-purchase', 600);
  }

  /* ==================================================================
     12. Imagens dos carrosseis

     O Slick move a faixa lateralmente, entao os slides fora da tela
     nunca disparam o lazy loading nativo e o visitante ve um quadro em
     branco ao arrastar. Aqui as imagens do carrossel viram "eager"
     quando a secao se aproxima da viewport.
     ================================================================== */

  function initSliderImages() {
    if (!('IntersectionObserver' in window)) return;

    var sliders = $$('.slick-slider, .slick-list, [class*="slider"]');
    if (!sliders.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        $$('img[loading="lazy"]', entry.target).forEach(function (img) {
          img.loading = 'eager';
          if (!img.complete && img.srcset) img.srcset = img.srcset;
        });
      });
    }, { rootMargin: '500px 0px' });

    sliders.forEach(function (el) { observer.observe(el); });
  }

  /* ==================================================================
     Inicializacao
     ================================================================== */

  onReady(function () {
    initDates();
    initTimers();
    initInteractions();
    initScrollEffects();
    initReviews();
    initSubscription();
    initLandingPrices();
    initIngredients();
    initPopup();
    initStickyBars();
    /* initSliderImages(): era para contornar o Slick, que movia a faixa
       lateralmente e impedia o lazy nativo de disparar. Com faixa rolavel
       de verdade o navegador resolve sozinho. */
  });
})();